module.exports = __webpack_public_path__ + "static/nxrt-automotive-86f93e93298520f73b26508f56b01f2b.jpg";